<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row>
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto pb-0"
      >
        <v-btn
          color="darktext"
          class="rounded-xxl text-none white--text px-4"
          @click="goBack"
        >
          <v-icon>mdi-chevron-left</v-icon>{{ $t('backToHub') }}
        </v-btn>
        <!-- <v-icon class="pb-1">mdi-chevron-left</v-icon>
                <a  class="mt-1"> {{$t('goBack')}}</a> -->
        <span class="float-right">
          <v-menu
            v-if="mobile()"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-2"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            >
              <v-list-item
                class="accent--text"
                :class="{'v-list-item--active': $route.name === 'HubOverview'}"
                @click="showHubOverview"
              >
                <v-list-item-title>{{ $t('overview') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :class="{'v-list-item--active': $route.name === 'PeopleInHub'}"
                @click="showHubMembers"
              >
                <v-list-item-title>{{ $tc('peopleInHubNumberTitle', peopleInHub) }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :class="{'v-list-item--active': $route.name === 'BoostersInHub'}"
                @click="showHubOwners"
              >
                <v-list-item-title>{{ $t('owners') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
        <p class="text-h5 font-weight-bold pt-5" :align="mobile() ? 'center' : 'left'">
          {{ $t('peopleInHubTitle') }}
        </p>
        <p class="text-body-1 greytext--text d-none d-md-block">
          {{ $t('peopleInHubText') }}
        </p>
      </v-col>
      <v-col
        v-if="!mobile()"
        cols="11"
        class="mx-auto custom-tab-menu py-0"
      >
        <v-list
          class="py-0"
          flat
        >
          <v-list-item
            class="accent--text"
            :class="{'v-list-item--active': $route.name === 'HubOverview'}"
            @click="showHubOverview"
          >
            {{ $t('overview') }}
          </v-list-item> 
          <v-list-item
            :class="{'v-list-item--active': $route.name === 'PeopleInHub'}"
            @click="showHubMembers"
          >
            {{ $t('people') }}
          </v-list-item>
          <v-list-item
            :class="{'v-list-item--active': $route.name === 'BoostersInHub'}"
            @click="showHubOwners"
          >
            {{ $t('owners') }}
          </v-list-item>
        </v-list> 
      </v-col>
    </v-row>
    <v-row
      v-if="!loadingData"
      align="center"
      justify="center"
      :class="mobile() ? 'pa-3' : ''"
    >
      <v-col
        :cols="mobile() ? '12' : '11'" 
        md="5"
        class="pa-md-12"
      >
        <v-card
          rounded="xxl"
          color="accent"
          class="white--text text-center mx-auto"
          max-width="600px"
          data-testid="people-card"
          :to="{ name: 'PeopleInHub' }"
        >
          <v-card-title
            class="justify-center text-h1 font-weight-bold py-10 no-break"
            data-testid="people-card-title"
          >
            {{ peopleInHub }}
          </v-card-title>
          <v-card-subtitle class="white--text text-h5 font-weight-bold mt-0 no-break">
            {{ $tc('people', peopleInHub) }}
          </v-card-subtitle>
          <v-card-text class="white--text text-body-2 pb-6 no-break">
            {{ $tc('peopleInHubNumberText', peopleInHub) }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        :cols="mobile() ? '12' : '11'" 
        md="5"
        class="pa-md-12"
      >
        <v-card
          rounded="xxl"
          color="darktext"
          class="white--text text-center mx-auto"
          max-width="600px"
          data-testid="boosters-card"
          :to="{ name: 'BoostersInHub' }"
        >
          <v-card-title
            class="justify-center text-h1 font-weight-bold py-10 no-break"
            data-testid="boosters-card-title"
          >
            {{ boostersInHub }}
          </v-card-title>
          <v-card-subtitle class="white--text text-h5 font-weight-bold mt-0 no-break">
            {{ $tc('boostersInHubNumberTitle', boostersInHub) }}
          </v-card-subtitle>
          <v-card-text class="white--text text-body-2 pb-6 no-break">
            {{ $tc('boostersInHubNumberText', boostersInHub) }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { getPeopleInHub, getBoostersInHub } from '../../api/hubApi'
import AlertMessages  from '../../components/AlertMessages'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'

export default {
    components: {
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            alertMsg:'',
            alertType:'',
            alertValue:false,
            hubId: this.$route.params.id,
            pageNumber: 1,
            size: 1,
            loadingData: false,
            peopleInHub: 0,
            boostersInHub: 0
        }
    },
    async created(){
        this.loadingData = true
        await this.fetchPeopleInHub()
        await this.fetchOwnersInHub()
        this.loadingData = false
    },
    methods:{
        async fetchPeopleInHub(){
            try {
                const response = await getPeopleInHub(this.hubId, this.pageNumber, this.size)
                if(response.status == 200) {
                    this.peopleInHub = response.data.meta.total
                }
                           
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async fetchOwnersInHub(){
            try {
                const response = await getBoostersInHub(this.hubId, this.pageNumber, this.size)
                if(response.status == 200) {
                    this.boostersInHub = response.data.meta.total
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        showHubOverview(){
            if (this.$route.name != 'HubOverview') {
                this.$router.push({path: '/hub/'+ this.hubId +'/overview'})
            }
        },
        showHubMembers(){
            if (this.$route.name != 'PeopleInHub') {
                this.$router.push({path: '/hub/'+ this.hubId +'/people'})
            }
        },
        showHubOwners(){
            if (this.$route.name != 'BoostersInHub') {
                this.$router.push({path: '/hub/'+ this.hubId +'/owners'})
            }
        },
        goBack(){
            // this.$router.push({path: this.$router.back()}).catch(()=>{})
           this.$router.push({path: '/hub/'+ this.hubId})
        },
    },
}
</script>
